import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IconSet from '../../../../../CMSComponent/icon'
import moment from 'moment'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux'
import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const checkCurrentUserMessage = (sender_id, current_user_id, ticker_user_id) => {
  if (current_user_id === ticker_user_id) {
    return sender_id === current_user_id
  }
  return sender_id !== ticker_user_id
}

const isImageAttachment = (url) => {
  if (!url || typeof url !== 'string') return false
  const path = url.split('?')[0].toLowerCase()
  return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/.test(path)
}

/** Same URL rule as header profile avatar (navHeaderButton) */
const resolvePhotoUrl = (photo) => {
  if (!photo || typeof photo !== 'string') return null
  if (photo.startsWith('http://') || photo.startsWith('https://') || photo.startsWith('data:')) {
    return photo
  }
  const base = process.env.REACT_APP_STORAGE || process.env.REACT_APP_URL_FILES || ''
  if (!base) return null
  return base + photo.replace(/^\//, '')
}

const UserAvatar = ({ photo, align = 'left' }) => {
  const src = resolvePhotoUrl(photo)
  const marginClass = align === 'right' ? 'ml-1' : 'mr-2'
  if (src) {
    return (
      <div className={`avatar-icon-wrapper ${marginClass}`}>
        <img
          src={src}
          alt=''
          height={40}
          width={40}
          style={{ borderRadius: '100%', objectFit: 'cover' }}
        />
      </div>
    )
  }
  return (
    <div className={`avatar-icon-wrapper ${marginClass}`}>
      <IconSet icon={'fa-regular fa-circle-user'} style={{ fontSize: '2rem', color: 'info', fontWeight: '300' }} color='info' />
    </div>
  )
}

const AttachmentPreview = ({ url, onPreviewImage }) => {
  if (!url) return null
  if (isImageAttachment(url)) {
    return (
      <div>
        <img
          className='cursor-pointer'
          src={url}
          alt='attachment'
          style={{ width: '20rem', maxHeight: '20rem' }}
          onClick={() => onPreviewImage(url)}
        />
      </div>
    )
  }
  const name = url.split('/').pop() || 'Download attachment'
  return (
    <div className='mt-1'>
      <a href={url} target='_blank' rel='noreferrer' className='subtitle1'>
        <i className='fa-solid fa-paperclip mr-1'></i>
        {decodeURIComponent(name)}
      </a>
    </div>
  )
}

const TicketChatListing = ({ chats, ticketDetails }) => {
  const currentUserData = useSelector((state) => state.User.user)
  const [showImage, setShowImage] = useState(false)
  const currentImageUrl = useRef(null)
  const ownPhoto = currentUserData?.photo || currentUserData?.profile
  const raiserPhoto = ticketDetails?.who_raised?.photo

  return (
    <div>
      <div className='chat-wrapper' style={{ maxHeight: 'calc(100vh - 20rem)', overflow: 'auto', height: '70%', minHeight: '30rem' }}>
        {chats?.map((item, index) => {
          const currentUserMessage = checkCurrentUserMessage(item?.sender_id, currentUserData?.id, ticketDetails?.ticket?.user_id)
          if (item?.sender_type === 'ticket_reopen' || item?.sender_type === 'ticket_closed') {
            return (
              <div className='d-flex align-items-center justify-content-center my-2 mx-5' style={{ opacity: 0.5 }} key={item?.id || index}>
                <hr style={{ flex: 1 }}></hr>
                <div className='subtitle1 mx-3'>{item?.message}</div>
                <hr style={{ flex: 1 }}></hr>
              </div>
            )
          }

          const senderPhoto =
            item?.sender_photo ||
            (item?.sender_id === currentUserData?.id ? ownPhoto : null) ||
            (item?.sender_id === ticketDetails?.ticket?.user_id ? raiserPhoto : null)

          if (currentUserMessage) {
            return (
              <div className='chat-box-wrapper' key={item?.id || index}>
                <div>
                  <UserAvatar photo={senderPhoto || ownPhoto} align='left' />
                </div>
                <div>
                  <div className='chat-box subtitle1'>
                    <AttachmentPreview
                      url={item?.attachment}
                      onPreviewImage={(url) => {
                        currentImageUrl.current = url
                        setShowImage(true)
                      }}
                    />
                    <div className='mt-2'> {item?.message}</div>
                  </div>
                  {item?.created_at && (
                    <small className='opacity-6' style={{ display: 'flex', alignItems: 'center' }}>
                      <FontAwesomeIcon icon={faCalendarAlt} className='mr-1' />
                      {moment(item?.created_at).format('HH:mm Do MMM, YYYY')}
                    </small>
                  )}
                </div>
              </div>
            )
          }

          return (
            <div className='chat-box-wrapper' style={{ flexDirection: 'row-reverse' }} key={item?.id || index}>
              <div className='chat-box-wrapper chat-box-wrapper-right'>
                <div>
                  <div className='chat-box subtitle1'>
                    <AttachmentPreview
                      url={item?.attachment}
                      onPreviewImage={(url) => {
                        currentImageUrl.current = url
                        setShowImage(true)
                      }}
                    />
                    <div className='mt-2'> {item?.message}</div>
                  </div>
                  {item?.created_at && (
                    <small className='opacity-6' style={{ display: 'flex', alignItems: 'center' }}>
                      <FontAwesomeIcon icon={faCalendarAlt} className='mr-1' />
                      {moment(item?.created_at).format('HH:mm Do MMM, YYYY')}
                    </small>
                  )}
                </div>
                <div>
                  <UserAvatar photo={senderPhoto} align='right' />
                </div>
              </div>
            </div>
          )
        })}
        <Modal
          isOpen={showImage}
          toggle={() => {
            setShowImage(false)
            currentImageUrl.current = null
          }}
          centered={true}
          style={{ maxWidth: '90vw', width: 'auto' }}>
          <ModalHeader
            toggle={() => {
              setShowImage(false)
              currentImageUrl.current = null
            }}>
            Preview
          </ModalHeader>
          <ModalBody>
            <div className='d-flex justify-content-center align-items-center'>
              <img src={currentImageUrl.current} style={{ maxWidth: '100%', maxHeight: '80vh' }} alt='Chat Attachment' />
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  )
}

export default TicketChatListing
